import { combineReducers } from "redux";

import themeReducer from "./themeReducer";
import authReducer from "./authReducer";
import mapReducer from "./mapReducer";

export const rootReducer = combineReducers({
  themeReducer,
  authReducer,
  mapReducer,
});
